import { TranslocoService } from '@ngneat/transloco';
import { Router, ActivatedRoute } from '@angular/router';
import { ToolboxCandidateModel } from 'projects/core/src/lib/models/toolbox-candidate.model';
import { Component, OnInit } from '@angular/core';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { BaseDetail } from 'projects/admin/src/app/classes/base-detail';
import { DetailModes } from 'projects/admin/src/app/shared/constants';
import { HelperService } from 'projects/admin/src/app/services/helper.service';

@Component({
  selector: 'app-toolbox-candidate-detail',
  templateUrl: './toolbox-candidate-detail.component.html',
  styleUrls: ['./toolbox-candidate-detail.component.scss']
})
export class ToolboxCandidateDetailComponent extends BaseDetail implements OnInit {

  public order: ToolboxCandidateModel = null;
  public backRoute = ['/toolbox-candidates'];

  protected identifier = 'toolbox-candidate';

  constructor(
    protected ui: UiService,
    protected router: Router,
    protected helper: HelperService,
    protected transloco: TranslocoService,
    private api: ApiService,
    private route: ActivatedRoute,
  ) {
    super(ui, router, helper, transloco);
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params.id === 'new') {
        this.setInitialized(DetailModes.new);
      } else if (params.id) {
        this.setLoading();
        this.api.getModel('toolbox-candidates', params.id).subscribe({
          next: (result: any) => {
            this.order = new ToolboxCandidateModel().deserialize(result.data);
            this.tabIndex = parseInt(localStorage.getItem(this.identifier + '-tab-' + this.order.id), 10);
            this.setInitialized(DetailModes.edit);
          },
          error: (error: any) => {
            this.setFailed(error);
          }
        });
      } else {
        this.onClose();
      }
    });
  }

  onUpdateOrder(order: ToolboxCandidateModel): void {
    this.order = order;
  }

  onTabChange(event: any): void {
    if (this.order !== null) {
      localStorage.setItem(this.identifier + '-tab-' + this.order.id, event.index);
    }
    this.ui.setFocus();
  }

  isDisabled(tab: string): boolean {
    let base = true;
    switch (tab) {
      case('results'): {
        base = this.order?.results_active;
        break;
      }
      case('credentials'): {
        base = this.order?.credentials_active;
        break;
      }
    }
    return (this.inEdit !== null && this.inEdit !== tab) || base !== true;
  }
}
